import { addDays } from "date-fns";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Swal from "sweetalert2";
// import appleBtn from "../../assets/img/appstore.webp";
// import googleBtn from "../../assets/img/google.webp";
// import ep from "../../assets/img/man.webp";
// import phoneBg from "../../assets/img/phonebg.webp";
import Button from "../../components/Button";
import Select from "../../components/Dropdown/index";
import Footer from "../../components/Footer";
import InputField from "../../components/InputField/index";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import Navbar from "../../components/NavBar";
import config from "../../configs";
import apiroutes from "../../services/apiroutes";
import { request, requestSetting } from "../../services/apiservice";
import { requestWallet } from "../../services/apiserviceWallet";
import { getAuth, setAuth, setAuthWallet } from "../../services/auth";
import BookSeat from "./BookSeat";
import BookStatus from "./BookingStatus";
import HireBus from "./HireBus";
import "./index.css";
import configs from "../../configs";
import { decrypt, encrypt } from "../../components/util";
import Appinstall from "../../components/Appinstall";

export const HomeComponent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [popularData, setPopularData] = useState([]);
  const [routeLoading, setRouteLoading] = useState(true);
  const [bookRouteNowVisible, setBookRouteNowVisible] = useState(false);
  const [popularRouteDestination, setPopularRouteDestination] = useState("");
  const [popularRouteDeparture, setPopularRouteDeparture] = useState("");
  const [popularRouteDepartureId, setPopularRouteDepartureId] = useState("");
  const [popularRouteDestinationId, setPopularRouteDestinationId] =
    useState("");
    const [departureTerminal, setDepartureTerminal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [adult, setAdult] = useState("1");
  const token = getAuth();
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const history = useHistory();
  useEffect(() => {
    getToken();
    // getWalletToken();
    // popularRoute();
    localStorage.removeItem("hireEmailAmount");
    localStorage.removeItem("transEmailAmount");
    localStorage.removeItem("estimatedTravelDistance");
    localStorage.removeItem("allHireDetails");
    localStorage.removeItem("selectedHireBuses");
    localStorage.removeItem("busNameQantity");
    localStorage.removeItem("returnPickupDate");
    localStorage.removeItem("userSelect");
    localStorage.removeItem("allTripDetails");
    localStorage.removeItem("selectedBusData");
    localStorage.removeItem("selectedSeats");
    localStorage.removeItem("selectedSeatsReturn");
    localStorage.removeItem("selectedReturnBusData");
    localStorage.removeItem("wovenAccountDetails");
    localStorage.removeItem("walletUserDetails");
    localStorage.removeItem("wovenWalletAccountDetails");
    localStorage.removeItem("walletPin");
    localStorage.removeItem("adults");
    localStorage.removeItem("adultsRound");
    localStorage.removeItem("retainBus");
    localStorage.removeItem("retainBusReturn");
  }, []);

  const getToken = async () => {
    const loginDetails = {
      userName: configs.USERNAME,
      // password: "web@@1.app12@gigm!@.com",
      password: configs.PASSWORD,
      deviceToken: "string",
      countryId: 1,
      clientId: configs.USERNAME,
    };
    const key = configs.ENCRYPT_KEY;
    const iv = configs.ENCRYPT_IV;

    const { ciphertext } = await encrypt(loginDetails, key, iv);

    const loginPayload = {credentials: ciphertext}
    request(apiroutes.GetToken(), "post", loginPayload)
      .then(async (res) => {
        const decryptedData = await decrypt( res.data.data, key, iv);
        // console.log(decryptedData, "NUGAGEEEEE 0000")

        setAuth(decryptedData?.Data?.JwtToken);
        getDepartureTerminal();
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const getDepartureTerminal = () => {
    requestSetting(apiroutes.DepartureTerminals(), "get", null, getAuth())
      .then((res) => {
        setDepartureTerminal(res.data?.data);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          getRefreshToken();
        }
      });
  };

  const getRefreshToken = () => {
    const payload = {
        token: getAuth(),
        refreshToken: "string"
    }
    request(apiroutes.GetNewToken(), "post", payload, null)
      .then((res) => {
        setAuth(res?.data?.data?.token);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((err) => {
        console.log(err.response);
        alert("Session Expired, Please log in");
        history.push("/login");
      });
  };

  const adults = [];
  for (let i = 1; i <= 13; i++) {
    adults.push(i);
  }
  const adultOptions = adults.map((x) => ({ label: x, value: x }));

  const colorStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: "1px dotted black",
      color: state.isSelected ? "white" : "black",
    }),
    singleValue: () => {
      const color = "black";

      return { color };
    },
  };

  const handleOneWay = (e) => {
    e.preventDefault();
    const newStartDate = new Date(startDate);
    let date = JSON.stringify(newStartDate);
    date = date.slice(1, 11);
    setLoading(true);
    const bookingData = {
      DepartureTerminalId: popularRouteDepartureId,
      DestinationTerminalId: popularRouteDestinationId,
      DepartureDate: date,
      NumberOfAdults: adult,
      TripType: "0",
      BookingType: "0",
      NumberOfChildren: "0",
    };

    const userSelect = {
      noOfAdult: adult,
      date: startDate,
      departureName: popularRouteDeparture.replace("=>", "-"),
      arrivalName: popularRouteDestination.replace("=>", "-"),
    };

    localStorage.setItem("userSelect", JSON.stringify(userSelect));

    request(apiroutes.BookingSearch(), "post", bookingData, token)
      .then((res) => {
        setLoading(false);
        if (res.data.Object === null) {
          // alert("Error validating your request, Please try again!");
          Swal.fire({
            showConfirmButton: false,
            timer: 4000,
            text: `Error validating your request, Please try again!`,
            icon: "error",
          });
          history.push("/");
          window.location.reload();
        } else {
          localStorage.setItem(
            "allTripDetails",
            JSON.stringify(res.data.Object)
          );
          history.push("/select-bus");
        }
      })
      .catch((err) => {
        // console.log(err.response);
        setLoading(false);
      });
  };

  const popularRoute = () => {
    request(apiroutes.GetpopularRoute(), "get")
      .then((res) => {
        // console.log(res);
        const data = res.data.Object;
        // console.log(data);
        setPopularData(data);
        setRouteLoading(false);
        // setAuthWallet(data);
      })
      .catch((err) => {
        // alert(err);
        console.log(err);
      });
  };

  const bookRouteNow = (item) => {
    // console.log(item, "Here are the popular items");
    setBookRouteNowVisible(true);
    setPopularRouteDestination(item.DestinationTerminalName);
    setPopularRouteDeparture(item.DepartureTerminalName);
    setPopularRouteDepartureId(item.DepartureTerminalId);
    setPopularRouteDestinationId(item.DestinationTerminalId);
  };

  const toggleModalClose = () => {
    setBookRouteNowVisible(false);
    // window.location.reload();
  };

  const width = 500;
  const height = 580;
  // const modalTitle = `Book a Bus from ${popularRouteDeparture} to ${popularRouteDestination}`;
  const modalTitle = `Book a Bus from ${popularRouteDeparture.replace(
    "=>",
    "-"
  )} to ${popularRouteDestination.replace("=>", "-")}`;
  const modalPar = "Please enter details below to proceed.";
  const modalBody = (
    <div>
      <label htmlFor="departure" className="label-auth">
        Travelling From
      </label>
      <InputField
        type="text"
        // placeholder="Verification code"
        value={popularRouteDeparture}
        onChangeMethod={(e) => setPopularRouteDeparture(e.target.value)}
        readonly={true}
      />
      <br />
      <br />
      <label htmlFor="arrival">Travelling To</label>
      <InputField
        type="text"
        // placeholder="Demmah16@gmail.com"
        value={popularRouteDestination}
        onChangeMethod={(e) => setPopularRouteDestination(e.target.value)}
        readonly={true}
      />
      <br />
      <br />
      <div className="row row-grid">
        <div className="col-md-6">
          <label className="label-auth">Departure Date</label>
          <DatePicker
            placeholderText="Select Date"
            selected={startDate}
            minDate={addDays(new Date(), 1)}
            maxDate={addDays(new Date(), 14)}
            onChange={(date) => setStartDate(date)}
            className="black"
            // readOnly={true}
          />
        </div>
        <div className="col-md-6">
          <label className="label-auth">Adults</label>
          <Select
            options={adultOptions}
            handleChange={(e) => setAdult(e.value)}
            defaultValue={{ label: "1", value: 1 }}
            value={adult}
            styles={colorStyles}
          />
        </div>
      </div>
      <br />
      <br />
      {/* <Button
        text="Proceed"
        handleButtonClick={verifyCode}
        disabled={!verificationCode}
        type="button"
      /> */}
      <div className="row">
        <div className="col-md-12">
          <Button
            text={
              loading ? (
                <div
                  style={{
                    display: "flex",
                    margin: "0 auto",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "200px",
                    transform: "translateX(-10px)",
                  }}
                >
                  <Loader dark={false} />{" "}
                  <p style={{ display: "inline-block" }}>Looking for Buses</p>
                </div>
              ) : (
                "Proceed"
              )
            }
            handleButtonClick={handleOneWay}
            type="button"
            btnstyle={{
              background: "#E21D00",
              color: "white",
              margin: "20px 0px",
              // fontFamily: "Euclid Circular B",
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            disabled={!(startDate && adult)}
          />
        </div>
      </div>
    </div>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          // dots: true,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 490,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // dots: true,
          autoplay: false,
        },
      },
    ],
  };

  return (
    <div id="top" style={{ width: "100vw", overflowX: "hidden" }}>
      <Modal
        width={width}
        height={height}
        visible={bookRouteNowVisible}
        title={modalTitle}
        paragraph={modalPar}
        body={modalBody}
        handleClose={toggleModalClose}
      />
      <Navbar />
      <section className="hero-bg">
        <div className="container">
          <div className="row row-grid">
            <div className="col-md-7 align-self-center">
              <h1>The modern way to commute across cities</h1>
              <br />
              <p>
                GIGM is an African technology powered company, providing
                seamless mobility services to commuters across Africa
              </p>
            </div>

            <div className="col-md-5">
              <section id="open-positions">
                <div className="positions">
                  <div className="position-filters">
                    <label
                      className={
                        toggleState === 1
                          ? "tabb-label active-tabs"
                          : "tabb-label"
                      }
                      onClick={() => toggleTab(1)}
                    >
                      Book a seat
                    </label>
                    <label
                      className={
                        toggleState === 2
                          ? "tabb-label active-tabs"
                          : "tabb-label"
                      }
                      onClick={() => toggleTab(2)}
                    >
                      Hire a bus
                    </label>
                    <label
                      className={
                        toggleState === 3
                          ? "tabb-label active-tabs"
                          : "tabb-label"
                      }
                      onClick={() => toggleTab(3)}
                    >
                      Booking status
                    </label>
                  </div>

                  <div
                    className={
                      toggleState === 1
                        ? "position-group  active-content"
                        : "position-group"
                    }
                  >
                    <div className="position-post">
                      <BookSeat departureTerminal={departureTerminal}/>
                    </div>
                  </div>
                  <div
                    className={
                      toggleState === 2
                        ? "position-group  active-content"
                        : "position-group"
                    }
                  >
                    <div className="position-post">
                      <HireBus />
                    </div>
                  </div>

                  <div
                    className={
                      toggleState === 3
                        ? "position-group  active-content"
                        : "position-group"
                    }
                  >
                    <div className="position-post">
                      <BookStatus />
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="app-section">
        <div className="app-section-text">
          <div className="">
            <h1>
              Enjoy the{" "}
              <span style={{ color: "red", background: "none" }}>
                GIGM Appvantage
              </span>
            </h1>
            <h1>Move Freely, Do Easily</h1>
            <p>
              It is all you need in one. Book bus tickets, hire a vehicle and
              pay bills.
            </p>
            <a target="_blank" rel="noreferrer" href="http://onelink.to/d4d9ke">
              <img
                src={googleBtn}
                alt=""
                className="download-btn-btn"
                loading="lazy"
              />
            </a>
            &nbsp;
            <a target="_blank" rel="noreferrer" href="http://onelink.to/d4d9ke">
              <img
                src={appleBtn}
                alt=""
                className="download-btn-btn"
                loading="lazy"
              />
            </a>
          </div>
        </div>
        <div className="app-section-image">
          <img
            src={phoneBg}
            alt=""
            className=""
            loading="lazy"
            style={{ width: "100%" }}
          />
        </div>
      </section> */}
        <Appinstall />
      <Footer />
    </div>
  );
};
export default HomeComponent;
